import { render } from "./Shipments.vue?vue&type=template&id=128892a0&ts=true"
import script from "./Shipments.vue?vue&type=script&lang=ts"
export * from "./Shipments.vue?vue&type=script&lang=ts"

import exportComponent from "/var/jenkins_home/workspace/saas-fulfillment-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__